import { theme } from "../../utils/theme";

export const styles = {
  bodyText: {
    color: theme.palette.grays[900],
    fontSize: {
      xs: theme.typography.body,
      md: theme.typography.body,
    },
    fontWeight: 300,
    letterSpacing: 0.9,
    textAlign: { xs: "center", md: "center" },
    textTransform: "normal",
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  imageContainer: {
    overflow: "hidden",
    height: { xs: 360, sm: 360, md: 420 },
  },
  item: {
    alignItems: { xs: "center", md: "center" },
    display: "flex",
    // minHeight: { xs: 280, sm: 280, md: 320 },
    px: { xs: 2, md: 2 },
    py: { xs: 8, md: 8 },
  },
  itemHeader: {
    color: theme.palette.secondary.main,
    fontSize: {
      xs: theme.typography.h3,
      md: theme.typography.h3,
    },
    fontWeight: 700,
    letterSpacing: 1.2,
    lineHeight: 1.1,
    textAlign: { xs: "center", md: "center" },
    width: { xs: "74%", md: "74%" },
  },
  itemText: {
    color: theme.palette.grays[900],
    fontSize: {
      xs: theme.typography.body,
      md: theme.typography.body,
    },
    textAlign: { xs: "center", md: "center" },
    width: { xs: "70%", md: "74%" },
  },
  margin: {
    display: "flex",
    margin: theme.spacing(1),
  },
};
